export default "__VITE_ASSET__DV3matc5__"